import { reactive } from 'vue';

export default {
    state: reactive({
        user: {
            isSystemAdmin: false,
            isSystemAdminEdit: false,
            isSiteAdmin: false,
        },
        service: {
            selecteServiceId: null,
            serviceTypes: [],
        },
        account: {
            useAbTest: false,
            useTargetReachCount: false,
            useDeliveryCalendar: false,
            useTrackingTag: false,
            useReminder: false,
        },
        resourceAccessRules: null
    }),
    setSystemAdmin: function(value) {
        this.state.user.isSystemAdmin = value;
    },
    setSystemAdminEdit: function(value) {
        this.state.user.isSystemAdminEdit = value;
    },
    setSiteAdmin: function(value) {
        this.state.user.isSiteAdmin = value;
    },
    selecteServiceId: function(value) {
        this.state.service.selecteServiceId = value;
    },
    setUseAbTest: function(value) {
        this.state.account.useAbTest = value;
    },
    setServiceTypes: function(value) {
        this.state.service.serviceTypes = value;
    },
    setUseTargetReachCount: function(value) {
        this.state.account.useTargetReachCount = value;
    },
    getServiceTypes: function() {
        return this.state.service.serviceTypes;
    },
    setUseDeliveryCalendar: function(value) {
        this.state.account.useDeliveryCalendar = value;
    },
    getUseDeliveryCalendar: function() {
        return this.state.account.useDeliveryCalendar;
    },
    setUseTrackingTag: function(value) {
        this.state.account.useTrackingTag = value;
    },
    getUseTrackingTag: function() {
        return this.state.account.useTrackingTag;
    },
    setUseReminder: function(value) {
        this.state.account.useReminder = value;
    },
    getUseReminder: function() {
        return this.state.account.useReminder;
    },
    setResourceAccessRules: function(value) {
        this.state.resourceAccessRules = value;
    },
    getResourceAccessRules: function() {
        return this.state.resourceAccessRules;
    }
}
